import { render, staticRenderFns } from "./voteResult.vue?vue&type=template&id=73133297&scoped=true&"
import script from "./voteResult.vue?vue&type=script&lang=js&"
export * from "./voteResult.vue?vue&type=script&lang=js&"
import style0 from "./voteResult.vue?vue&type=style&index=0&id=73133297&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73133297",
  null
  
)

export default component.exports